module.exports = __webpack_public_path__ + "static/img/15.07f9ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/15.png
// module id = TU/F
// module chunks = 0